import request from '@/utils/request';
// const PREFIX = '/fmis/fmis'
const PREFIX = '/fmis';

// 预付账
// 乐惠预付入账
export function advanceAccountEnter(data) {
  return request({
    url: `${PREFIX}/payinadvanceaccountlogs/addLhPayInAdvanceAccount`,
    method: 'post',
    data,
  });
}

// 现付账入账
export function cashAccountEnter(data) {
  return request({
    url: `${PREFIX}/payCashAccountController/addLhPayCashAccount`,
    method: 'post',
    data,
  });
}

// 押金入账
export function depositAccountEnter(data) {
  return request({
    url: `/order/web/account/lhDepositEnterSm`,
    method: 'post',
    data,
  });
}

// 乐惠部分结账
export function leHuiPartSettle(data) {
  return request({
    url: `/order/web/account/lhPartSettle`,
    method: 'post',
    data,
  });
}

// 乐惠预付账入账
export function leHuiInadvanceAccountEnter(params) {
  return request({
    url: `${PREFIX}/payinadvanceaccountlogs/addPayInAdvanceAccount`,
    method: 'post',
    params: params,
  });
}

// 乐惠现付账入账
export function leHuiCashAccountEnter(params) {
  return request({
    url: `${PREFIX}/payCashAccountController/addLhPayCashAccount`,
    method: 'post',
    params: params,
  });
}

// 乐惠结账
export function leHuiSettle(data) {
  return request({
    url: `/order/web/account/settle`,
    method: 'post',
    data,
  });
}
// 乐惠支付状态查询
// /fmis/payrecord/payRecordType
export function queryPayStatus(params) {
  return request({
    // url: `${PREFIX}/payrecord/payRecordType`,
    url: `${PREFIX}/payrecord/payResult`,
    method: 'get',
    params: params,
  });
}
// 乐惠入账
export function lehuiEnterAccount(data) {
  return request({
    url: `/order/web/account/room/enter`,
    method: 'post',
    data,
    showLoading: true,
  });
}
// 获取详情列表
export function getList(params) {
  return request({
    url: `${PREFIX}/account/list`,
    method: 'get',
    params,
  });
}
// 导出详情列表
export function exportAccountList(params) {
  return request({
    url: `${PREFIX}/account/export/list`,
    method: 'get',
    params,
  });
}
// 获取酒店操作人
export function queryOperator(params) {
  return request({
    url: `${PREFIX}/account/queryOperator`,
    method: 'get',
    params,
  });
}
// 获取联防单详情
export function accountListByOrderRoomS(data) {
  return request({
    url: `${PREFIX}/account/accountListByOrderRoomS`,
    method: 'POST',
    notCheckRepeat: true,
    data,
  });
}
// 批量加收房费
export function createRoomRateS(data) {
  return request({
    url: `/order/web/account/batchAddFee`,
    method: 'POST',
    data,
  });
}
// 小时房加收金额
export function hourRoomSettle(params) {
  return request({
    url: `${PREFIX}/account/hourRoomSettle`,
    method: 'get',
    params,
  });
}
// 押金打印
// export function depositPrint(params) {
//   return request({
//     url: `${PREFIX}/account/depositPrint`,
//     method: 'get',
//     params
//   })
// }
// 账单明细
export function billPrintAccount(params) {
  return request({
    url: `${PREFIX}/account/billPrintAccount`,
    method: 'get',
    params,
  });
}
// 批量结账
export function orderRoomListSettle(data) {
  return request({
    url: `/order/web/account/batchSettle`,
    method: 'POST',
    data,
  });
}
// 批量挂账
export function hangingRoomAccountS(data) {
  return request({
    url: `/order/web/account/batchHang`,
    method: 'POST',
    data,
  });
}
// 预付账套入账
export function addPayInAdvanceAccount(data) {
  return request({
    url: `${PREFIX}/payinadvanceaccountlogs/addPayInAdvanceAccount`,
    method: 'POST',
    data,
  });
}
// 预付账套充值记录
export function getPayInAdvanceAccountList(params) {
  return request({
    url: `${PREFIX}/payinadvanceaccountlogs/getPayInAdvanceAccountList`,
    method: 'get',
    params,
  });
}
// 入账
export function enterAccount(data) {
  return request({
    url: `/order/web/account/room/enter`,
    method: 'post',
    data,
    showLoading: true,
  });
}
// 订单列表
export function accountListByOrderNo(params) {
  return request({
    url: `${PREFIX}/account/accountListByOrderNo`,
    method: 'get',
    params,
    showLoading: true,
  });
}
export function queryOrderRoomForFmis(params) {
  return request({
    url: '/order/houseKeeper/queryOrderRoomForFmis',
    method: 'get',
    params,
    showLoading: true,
  });
}
// 查询钟点房生成房费
export function fetchHourRoomFee(data) {
  return request({
    url: `${PREFIX}/account/hourRoomListSettle`,
    method: 'post',
    data,
  });
}
// 生成房费
export function creactCount(data) {
  return request({
    url: `/order/web/account/addFee`,
    method: 'post',
    data,
    showLoading: true,
  });
}
// 结账
export function settleAccount(data) {
  return request({
    url: `/order/web/account/settle`,
    method: 'post',
    data,
    showLoading: true,
  });
}
// 转账
export function transformAccount(data) {
  return request({
    url: `/order/web/account/transfer`,
    method: 'post',
    data,
    showLoading: true,
  });
}
// 挂账退房
export function hangingRoomAccount(data) {
  return request({
    url: `/order/web/account/hang`,
    method: 'post',
    data,
    showLoading: true,
  });
}
// 订单账获取金额
export function countOrderMoney(params) {
  return request({
    url: `${PREFIX}/account/countOrderMoney`,
    method: 'get',
    params,
    showLoading: true,
  });
}
// 拆账/ 挂账
export function tearAccount(data) {
  return request({
    url: `/order/web/account/reverseSettle`,
    method: 'post',
    data,
    showLoading: true,
  });
}
// 部分结账
export function revokeAccountList(params) {
  return request({
    url: `${PREFIX}/account/revokeAccountList`,
    // url: `/order/web/account/tear`,
    method: 'get',
    params,
    showLoading: true,
  });
}
// 账务金额
export function amountAccount(params) {
  return request({
    url: `${PREFIX}/account/amount`,
    method: 'get',
    params,
  });
}

// 账务金额
export function orderAmount(params) {
  return request({
    url: `${PREFIX}/account/orderAmount`,
    method: 'get',
    params,
  });
}

// 入账
export function roomadjust(data) {
  return request({
    url: `/order/web/account/room/adjustRoomBill`,
    method: 'post',
    data,
    showLoading: true,
  });
}

// 查询房单AR账余额
export function queryRoomArAccountList(params) {
  return request({
    url: `/fmis/account/queryRoomArAccountList`,
    method: 'get',
    params,
  });
}

// ~~~~~~~~~~~现付账
// 现付账-添加现付账
export function addPayCashAccount(data) {
  return request({
    url: `${PREFIX}/payCashAccountController/addPayCashAccount`,
    method: 'post',
    data,
  });
}
// 现付账-现付账列表
export function payCashAccountList(data) {
  return request({
    url: `${PREFIX}/payCashAccountController/payCashAccountList`,
    method: 'post',
    data,
    notCheckRepeat: true,
  });
}
// 现付账-冲账
export function balanceccountList(data) {
  return request({
    url: `${PREFIX}/payCashAccountController/balanceccountList`,
    method: 'post',
    data,
  });
}
// 科目-消费科目列表
export function subjectList(params) {
  return request({
    url: `${PREFIX}/subjectController/subject`,
    method: 'get',
    params,
  });
}
// 打印现付账账单明细
export function fetchPrintDataBySubject(params) {
  return request({
    url: `${PREFIX}/report/printPayCashAccount`,
    method: 'get',
    params,
  });
}
// 现付账-小商品支付失败时释放库存
export function releaseStockWhenPayFailed(params) {
  return request({
    url: `${PREFIX}/payCashAccountController/goodsRepeal`,
    method: 'get',
    params,
  });
}
// 退款科目
export function fetchRefundSubjectList(params) {
  return request({
    url: `${PREFIX}/subjectController/getRefundSubject`,
    method: 'post',
    data: params,
  });
}
// 现付账-账套
// 现付账-账套列表-分页
export function accountSuitPageList(data) {
  return request({
    url: `${PREFIX}/accountSuitController/accountSuitPageList`,
    method: 'post',
    data,
  });
}
// 现付账-账套列表-不分页
export function accountSuitList(params) {
  return request({
    url: `${PREFIX}/accountSuitController/accountSuitList`,
    method: 'get',
    params,
  });
}
// 现付账-添加账套
export function addAccountSuit(data) {
  return request({
    url: `${PREFIX}/accountSuitController/addAccountSuit`,
    method: 'post',
    data,
  });
}
// 现付账-编辑账套
export function updateAccountSuit(data) {
  return request({
    url: `${PREFIX}/accountSuitController/updateAccountSuit`,
    method: 'post',
    data,
  });
}
// 科目-根据二级科目编号，查询父级信息
export function getSubjectPid(params) {
  return request({
    url: `${PREFIX}/subjectController/getSubjectPid`,
    method: 'get',
    params,
  });
}
// 应收账-应收账列表
export function verificatelist(data) {
  return request({
    url: `${PREFIX}/verificateController/verificatelist`,
    method: 'post',
    data,
    notCheckRepeat: true,
  });
}
// 应收账-头部信息
export function topMessage(params) {
  return request({
    url: `${PREFIX}/verificateController/topMessage`,
    method: 'get',
    params,
  });
}
// 应收账-核销
export function verificateMsg(data) {
  return request({
    url: `${PREFIX}/verificateController/verificateMsg`,
    method: 'post',
    data,
  });
}

// 应收账-反核销
export function reverseVerificateMsg(data) {
  return request({
    url: `${PREFIX}/verificateController/reverseVerificateMsg`,
    method: 'post',
    data,
  });
}
// 应收账-核销记录
export function verificateRecordlist(params) {
  return request({
    url: `${PREFIX}/verificateController/verificateRecordlist`,
    method: 'get',
    params,
  });
}
// 应收账--选择渠道
// export function getChannelType(params) {
//   return request({
//     url: `${PREFIX}/verificateController/getChannelType`,
//     method: 'get',
//     params
//   })
// }
export function getChannelType(params) {
  return request({
    url: 'room/channel/allModeChannel',
    method: 'get',
    params,
  });
}

// 应收账--账套列表-不分页,`${PREFIX}/receiveAccountController/receiveAccountList`
export function receiveAccountList(data) {
  return request({
    url: `${PREFIX}/receiveAccountController/receiveAccounts`,
    method: 'get',
    params: data,
  });
}
// 应收账--账套列表-分页
export function receiveAccountPageList(data) {
  return request({
    url: `${PREFIX}/receiveAccountController/receiveAccountPageList`,
    method: 'post',
    data,
    notCheckRepeat: true,
  });
}
// 应收账--添加账套
export function addReceiveAccount(data) {
  return request({
    url: `${PREFIX}/receiveAccountController/addReceiveAccount`,
    method: 'post',
    data,
  });
}
// 应收账--编辑账套
export function updateReceiveAccount(data) {
  return request({
    url: `${PREFIX}/receiveAccountController/updateReceiveAccount`,
    method: 'post',
    data,
  });
}
// 应收账--账套类型
export function accountTypes(data) {
  return request({
    url: `${PREFIX}/receiveAccountController/accountTypes`,
    method: 'post',
    data,
  });
}
// 应收账--AR账列表
export function receiveAccountByCompanyId(params) {
  return request({
    url: `${PREFIX}/receiveAccountController/receiveAccountByCompanyId`,
    method: 'get',
    params,
  });
}
// 订单账--入账
export function enterOrder(data) {
  return request({
    url: `/order/web/account/order/enter`,
    method: 'post',
    data,
    showLoading: true,
  });
}
// 订单账--结账
export function orderSettle(data) {
  return request({
    url: `${PREFIX}/account/orderSettle`,
    method: 'post',
    data,
    showLoading: true,
  });
}
// 订单账--撤销结账列表
export function revokeOrderAccountList(params) {
  return request({
    url: `${PREFIX}/account/revokeOrderAccountList`,
    method: 'get',
    params,
    showLoading: true,
  });
}
// 房单账查询信用住杂费
export function fetchCreditFee(params) {
  return request({
    url: `${PREFIX}/account/roomRateFee`,
    method: 'get',
    params,
  });
}
// 根据协议公司id查询可用的AR账户列表
export function groupFetchListByCompanyId(params) {
  return request({
    url: `${PREFIX}/receiveAccountController/reAccountByCompanyIds`,
    method: 'post',
    data: params,
  });
}
// 房单拆账
export function accountTear(data) {
  return request({
    url: `/order/web/account/tear`,
    method: 'post',
    data,
    showLoading: true,
  });
}
// 撤销结账
export function reverseSettle(data) {
  return request({
    url: `/order/web/account/reverseSettle`,
    method: 'post',
    data,
    showLoading: true,
  });
}
// 部分结账-房单
export function partSettleRoom(data) {
  return request({
    url: `/order/web/account/room/partSettle`,
    method: 'post',
    data,
    showLoading: true,
  });
}
// 部分结账-订单
export function partSettleOrder(data) {
  return request({
    url: `/order/web/account/order/partSettle`,
    method: 'post',
    data,
    showLoading: true,
  });
}
// 冲账
export function reverseAccount(data) {
  return request({
    url: `/order/web/account/reverse`,
    method: 'post',
    data,
    showLoading: true,
  });
}
// 修改账务备注
export function updateAccountRemark(data) {
  return request({
    url: `/order/web/account/updateRemark`,
    method: 'post',
    data,
    showLoading: true,
  });
}
// 获取付款科目报表的付款科目下拉
export function paymentOptionsList(data) {
  return request({
    url: `${PREFIX}/subjectController/getSettleSubject`,
    method: 'get',
    params: data,
  });
}

//全部核销接口，POST方式 ，参数与查询接口一致
export function verificateMsgAll(data) {
  return request({
    url: `${PREFIX}/verificateController/verificateMsgAll`,
    method: 'post',
    data: data,
  });
}

//全部反核销接口，POST方式 ，参数与查询接口一致
export function verificateResMsgAll(data) {
  return request({
    url: `${PREFIX}/verificateController/verificateResMsgAll`,
    method: 'post',
    data: data,
  });
}

//导出列表接口，POST方式 ，参数与查询接口一致
export function verificatelistExport(data) {
  return request({
    url: `${PREFIX}/verificateController/export/verificatelist`,
    method: 'post',
    responseType: 'blob',
    data: data,
  });
}

// 预售权转账
export function transferPreAuthority(data) {
  return request({
    url: `/order/preAuth/transPreAuth`,
    method: 'post',
    data,
    showLoading: true,
  });
}

// 退押金
export function accountapplyRefund(data) {
  return request({
    url: `/fmis/account/applyRefund4Deposit`,
    method: 'post',
    data,
    showLoading: true,
  });
}

// 是否开通线上支付
export function isOpen(data) {
  return request({
    url: `${PREFIX}/subjectController/isOpen`,
    method: 'get',
    params: data,
  });
}

// 现付账-删除账套
export function delAccountSuit(data) {
  return request({
    url: `${PREFIX}/accountSuitController/delAccountSuit`,
    method: 'post',
    data,
  });
}

// 开放批量转账接口	
export function batchTransferInterface(data) {
  return request({
    url: `/order/web/account/batchTransfer`,
    method: 'post',
    data,
  });
}
